import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useUser } from '../context/UserContext';

export default function PrivateRoute({ children }) {
  const { user, loading } = useUser();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  return children;
}
